// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Route from "../Route.bs.js";
import * as Share from "../common/Share.bs.js";
import * as React from "react";
import * as Region from "common/src/Region.bs.js";
import * as Router from "common/src/Router.bs.js";
import * as Select from "../components/Select.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as PlBanner from "./PlBanner.bs.js";
import * as PlFilter from "./PlFilter.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as PlAltRanks from "./PlAltRanks.bs.js";
import * as PlStatsTab from "./PlStatsTab.bs.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as PlBannerHor from "./PlBannerHor.bs.js";
import * as PlMatchList from "./PlMatchList.bs.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as PlGlobalStats from "./PlGlobalStats.bs.js";
import * as AdHorInContent from "../ads/AdHorInContent.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as PlUnitsSummary from "./PlUnitsSummary.bs.js";
import * as PlTraitsSummary from "./PlTraitsSummary.bs.js";
import Tab from "@mui/material/Tab";
import * as PlAugmentsSummary from "./PlAugmentsSummary.bs.js";
import Tabs from "@mui/material/Tabs";
import * as PlUnitItemsSummary from "./PlUnitItemsSummary.bs.js";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Select$1 from "@mui/material/Select";
import * as PlCurrentPerformance from "./PlCurrentPerformance.bs.js";
import MenuItem from "@mui/material/MenuItem";
import Done from "@mui/icons-material/Done";
import * as PlayerRadarModalContents from "../player/PlayerRadarModalContents.bs.js";
import CircularProgress from "@mui/material/CircularProgress";

function PlInfo$TopTabs(Props) {
  var tab = Props.tab;
  var onChange = Props.onChange;
  var hasRankedMatches = Props.hasRankedMatches;
  var hasHrMatches = Props.hasHrMatches;
  var hasDuoMatches = Props.hasDuoMatches;
  var hasNormalMatches = Props.hasNormalMatches;
  return React.createElement("div", {
              className: "bg-bg rounded w-full sm:w-auto order-2 md:order-1"
            }, React.createElement(Tabs, {
                  variant: "scrollable",
                  children: Belt_Array.map(PlFilter.Type.all, (function (v) {
                          var disabled;
                          switch (v) {
                            case /* All */0 :
                                disabled = false;
                                break;
                            case /* Ranked */1 :
                                disabled = !hasRankedMatches;
                                break;
                            case /* Normal */2 :
                                disabled = !hasNormalMatches;
                                break;
                            case /* Hyperroll */3 :
                                disabled = !hasHrMatches;
                                break;
                            case /* Duo */4 :
                                disabled = !hasDuoMatches;
                                break;
                            
                          }
                          if (disabled) {
                            return React.createElement(Tab, {
                                        label: React.createElement(Tooltip.make, {
                                              title: "No " + PlFilter.Type.toName(v) + " games played",
                                              children: React.createElement("span", undefined, PlFilter.Type.toName(v))
                                            }),
                                        value: PlFilter.Type.toKey(v),
                                        disabled: disabled,
                                        classes: {
                                          root: "!pointer-events-auto !cursor-not-allowed pb-3 pt-3"
                                        },
                                        key: PlFilter.Type.toKey(v)
                                      });
                          } else {
                            return React.createElement(Tab, {
                                        label: PlFilter.Type.toName(v),
                                        value: PlFilter.Type.toKey(v),
                                        disabled: disabled,
                                        key: PlFilter.Type.toKey(v)
                                      });
                          }
                        })),
                  value: PlFilter.Type.toKey(tab),
                  onChange: (function (param, t) {
                      return Curry._1(onChange, PlFilter.Type.fromKey(t));
                    })
                }));
}

var TopTabs = {
  make: PlInfo$TopTabs
};

function PlInfo$ExtraButtons(Props) {
  var updating = Props.updating;
  var recentlyUpdated = Props.recentlyUpdated;
  var onUpdatePlayer = Props.onUpdatePlayer;
  var region = Props.region;
  var playerName = Props.playerName;
  var tag = Props.tag;
  return React.createElement("div", {
              className: "rounded p-2 flex items-center h-12"
            }, React.createElement("div", {
                  className: "mr-3"
                }, React.createElement(Share.Button.make, {
                      forceFull: true,
                      url: Route.toString({
                            TAG: /* Player */2,
                            _0: {
                              region: region,
                              playerName: playerName,
                              tag: tag,
                              match: undefined
                            }
                          })
                    })), React.createElement(Button, {
                  disabled: !updating && recentlyUpdated,
                  classes: {
                    root: "w-[120px]"
                  },
                  onClick: (function (param) {
                      return Curry._1(onUpdatePlayer, undefined);
                    }),
                  variant: "outlined",
                  size: "small",
                  children: updating ? React.createElement(React.Fragment, undefined, React.createElement(CircularProgress, {
                              size: 16
                            }), React.createElement("div", {
                              className: "ml-2"
                            }, "Updating")) : (
                      recentlyUpdated ? React.createElement("div", {
                              className: "flex items-center"
                            }, React.createElement(Done, {
                                  fontSize: "small"
                                }), React.createElement("div", {
                                  className: "ml-2"
                                }, "Updated")) : React.createElement("div", undefined, "Update")
                    )
                }));
}

var make = React.memo(PlInfo$ExtraButtons);

var ExtraButtons = {
  make: make
};

function tabToKey(tab) {
  switch (tab) {
    case /* Stats */0 :
        return "Stats";
    case /* Units */1 :
        return "Units";
    case /* Traits */2 :
        return "Traits";
    case /* Items */3 :
        return "Items";
    case /* Augments */4 :
        return "Augments";
    
  }
}

function tabFromKey(tab) {
  switch (tab) {
    case "Augments" :
        return /* Augments */4;
    case "Items" :
        return /* Items */3;
    case "Stats" :
        return /* Stats */0;
    case "Traits" :
        return /* Traits */2;
    case "Units" :
        return /* Units */1;
    default:
      throw {
            RE_EXN_ID: "Assert_failure",
            _1: [
              "PlInfo.res",
              123,
              9
            ],
            Error: new Error()
          };
  }
}

function PlInfo(Props) {
  var adKey = Props.adKey;
  var region = Props.region;
  var player = Props.player;
  var allNormalGames = Props.allNormalGames;
  var allRankedGames = Props.allRankedGames;
  var allHrGames = Props.allHrGames;
  var allDuoGames = Props.allDuoGames;
  var allOtherGames = Props.allOtherGames;
  var setExpandedMatchId = Props.setExpandedMatchId;
  var onHoverMatch = Props.onHoverMatch;
  var masterRanks = Props.masterRanks;
  var updating = Props.updating;
  var recentlyUpdated = Props.recentlyUpdated;
  var onUpdatePlayer = Props.onUpdatePlayer;
  var ranks = Props.ranks;
  var set = TftSet.use(undefined);
  Router.use(undefined);
  var screenSize = ScreenAtom.use(undefined);
  var match = React.useState(function () {
        return PlFilter.$$default;
      });
  var setFilter = match[1];
  var filter = match[0];
  var match$1 = React.useState(function () {
        return /* Stats */0;
      });
  var setTab = match$1[1];
  var tab = match$1[0];
  var statsScrollRef = React.useRef(null);
  var match$2 = React.useState(function () {
        return false;
      });
  var setShowPlayerRadarInfo = match$2[1];
  var showPlayerRadarInfo = match$2[0];
  var topRank = Belt_Array.reduce(player.rankHistory, undefined, (function (acc, d) {
          if (acc !== undefined && (LpChartUtils.divisionToBase(d[1], set) + d[2] | 0) <= (LpChartUtils.divisionToBase(acc[1], set) + acc[2] | 0)) {
            return acc;
          } else {
            return d;
          }
        }));
  var topDuoRank = Belt_Array.reduce(player.duoRankHistory, undefined, (function (acc, d) {
          if (acc !== undefined && (LpChartUtils.divisionToBase(d[1], set) + d[2] | 0) <= (LpChartUtils.divisionToBase(acc[1], set) + acc[2] | 0)) {
            return acc;
          } else {
            return d;
          }
        }));
  var topHrRank = Belt_Array.reduce(player.hrRankHistory, undefined, (function (acc, d) {
          if (acc !== undefined && (LpChartUtils.divisionToBase(d[1], set) + d[2] | 0) <= (LpChartUtils.divisionToBase(acc[1], set) + acc[2] | 0)) {
            return acc;
          } else {
            return d;
          }
        }));
  var match$3 = Belt_Array.get(player.matches, 0);
  var match$4 = Belt_Option.flatMap(allNormalGames, (function (ang) {
          return Belt_Array.get(ang, 0);
        }));
  var companionId = match$3 !== undefined ? match$3.info.companionId : (
      match$4 !== undefined ? match$4.info.companionId : ""
    );
  var match$5 = filter.typ;
  var showLp = match$5 < 2;
  var allGames = React.useMemo((function () {
          var match = filter.typ;
          switch (match) {
            case /* All */0 :
                if (allRankedGames !== undefined && allNormalGames !== undefined && allHrGames !== undefined && allDuoGames !== undefined) {
                  return Belt_SortArray.stableSortBy(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(Belt_Array.concat(allRankedGames, allNormalGames), allHrGames), allDuoGames), allOtherGames), (function (hp1, hp2) {
                                return Caml.caml_float_compare(hp2.dateTime, hp1.dateTime);
                              }));
                } else {
                  return player.matches;
                }
            case /* Ranked */1 :
                return Belt_Option.getWithDefault(allRankedGames, Belt_Array.keep(player.matches, (function (m) {
                                  return m.queueId === 1100;
                                })));
            case /* Normal */2 :
                return Belt_Option.getWithDefault(allNormalGames, Belt_Array.keep(player.matches, (function (m) {
                                  return m.queueId === 1090;
                                })));
            case /* Hyperroll */3 :
                return Belt_Option.getWithDefault(allHrGames, Belt_Array.keep(player.matches, (function (m) {
                                  return m.queueId === 1130;
                                })));
            case /* Duo */4 :
                return Belt_Option.getWithDefault(allDuoGames, Belt_Array.keep(player.matches, (function (m) {
                                  if (m.queueId === 1150) {
                                    return true;
                                  } else {
                                    return m.queueId === 1160;
                                  }
                                })));
            
          }
        }), [
        filter,
        allRankedGames,
        allNormalGames,
        allHrGames,
        player
      ]);
  var matches = React.useMemo((function () {
          var match = filter.aperture;
          if (typeof match === "number") {
            switch (match) {
              case /* Last20 */0 :
                  return Belt_Array.slice(allGames, 0, 20);
              case /* Last50 */1 :
                  return Belt_Array.slice(allGames, 0, 50);
              case /* Last100 */2 :
                  return Belt_Array.slice(allGames, 0, 100);
              case /* Last200 */3 :
                  return Belt_Array.slice(allGames, 0, 200);
              case /* All */4 :
                  return allGames;
              
            }
          } else {
            var patch = match._0;
            return Belt_Array.keep(allGames, (function (g) {
                          return g.patch === patch;
                        }));
          }
        }), [
        filter,
        allGames
      ]);
  var allMatches = React.useMemo((function () {
          if (allRankedGames !== undefined && allNormalGames !== undefined && allHrGames !== undefined && allDuoGames !== undefined) {
            return Belt_Array.concatMany([
                        allRankedGames,
                        allNormalGames,
                        allHrGames,
                        allDuoGames,
                        allOtherGames
                      ]);
          } else {
            return player.matches;
          }
        }), [
        allRankedGames,
        allNormalGames,
        allHrGames,
        allDuoGames,
        allOtherGames
      ]);
  var allMatches$1 = Belt_SortArray.stableSortBy(allMatches, (function (m1, m2) {
          return Caml.caml_float_compare(m2.dateTime, m1.dateTime);
        }));
  var match$6 = React.useMemo((function () {
          return [
                  Belt_Array.some(allMatches$1, (function (mi) {
                          return mi.queueId === 1100;
                        })),
                  Belt_Array.some(allMatches$1, (function (mi) {
                          return mi.queueId === 1160;
                        })),
                  Belt_Array.some(allMatches$1, (function (mi) {
                          return mi.queueId === 1130;
                        })),
                  Belt_Array.some(allMatches$1, (function (mi) {
                          return mi.queueId === 1090;
                        }))
                ];
        }), [allMatches$1]);
  var onShowDetails = React.useCallback((function (matchId) {
          return Curry._1(setExpandedMatchId, matchId);
        }), [player]);
  var onShowPlayerRadarInfo = React.useCallback((function (param) {
          return Curry._1(setShowPlayerRadarInfo, (function (param) {
                        return true;
                      }));
        }), []);
  var seasonStats = player.seasonStats;
  if (seasonStats == null) {
    return React.createElement(ContentSection.make, {
                children: "No data available for player " + player.playerInfo.name + " in " + Region.toName3(region) + " region."
              });
  }
  var match$7 = filter.typ;
  var queueId;
  switch (match$7) {
    case /* All */0 :
        queueId = undefined;
        break;
    case /* Ranked */1 :
        queueId = 1100;
        break;
    case /* Normal */2 :
        queueId = 1090;
        break;
    case /* Hyperroll */3 :
        queueId = 1130;
        break;
    case /* Duo */4 :
        queueId = 1160;
        break;
    
  }
  var seasonStats$1 = Belt_Option.getWithDefault(Belt_Option.flatMap(queueId, (function (qid) {
              return Js_dict.get(player.queueSeasonStats, String(qid));
            })), seasonStats);
  var match$8 = filter.typ;
  var match$9 = filter.typ;
  var match$10 = filter.typ;
  var match$11 = filter.typ;
  var match$12 = filter.typ;
  var match$13 = filter.typ;
  var match$14 = filter.typ;
  var match$15 = filter.typ;
  var match$16 = filter.typ;
  var match$17 = filter.typ;
  var filterEl = React.createElement("div", {
        className: "sm:p-3 flex items-center justify-start h-[52px]"
      }, React.createElement("div", undefined, React.createElement(Select$1, {
                native: screenSize >= 4,
                classes: {
                  select: "text-[14px] pb-[3px] pt-[2px] pr-[22px]",
                  icon: "text-[22px]"
                },
                value: PlFilter.Aperture.toKey(filter.aperture),
                onChange: (function (e) {
                    return Curry._1(setFilter, (function (filter) {
                                  return {
                                          aperture: PlFilter.Aperture.fromKey(e.target.value),
                                          typ: filter.typ
                                        };
                                }));
                  }),
                className: "text-right min-w-[82px]",
                variant: "standard",
                children: Belt_Array.map(Belt_Array.keep(PlFilter.Aperture.all, (function (aperture) {
                            if (typeof aperture === "number") {
                              return true;
                            }
                            var patch = aperture._0;
                            return Belt_Array.some(allGames, (function (mi) {
                                          return mi.patch === patch;
                                        }));
                          })), (function (aperture) {
                        if (screenSize >= 4) {
                          return React.createElement("option", {
                                      key: PlFilter.Aperture.toKey(aperture),
                                      value: PlFilter.Aperture.toKey(aperture)
                                    }, PlFilter.Aperture.toName(aperture));
                        } else {
                          return React.createElement(MenuItem, {
                                      value: PlFilter.Aperture.toKey(aperture),
                                      children: PlFilter.Aperture.toName(aperture),
                                      key: PlFilter.Aperture.toKey(aperture)
                                    });
                        }
                      }))
              })));
  var tmp;
  switch (tab) {
    case /* Stats */0 :
        tmp = React.createElement(PlStatsTab.make, {
              filter: filter,
              matches: matches,
              player: player,
              onShowDetails: onShowDetails,
              onShowPlayerRadarInfo: onShowPlayerRadarInfo,
              masterRanks: masterRanks,
              forceTimeChart: filter.aperture === /* All */4
            });
        break;
    case /* Units */1 :
        tmp = React.createElement(PlUnitsSummary.make, {
              showLp: showLp,
              games: matches,
              top: "t0",
              isDuo: filter.typ === /* Duo */4,
              scrollRef: statsScrollRef.current
            });
        break;
    case /* Traits */2 :
        tmp = React.createElement(PlTraitsSummary.make, {
              showLp: showLp,
              games: matches,
              top: "t0",
              isDuo: filter.typ === /* Duo */4,
              scrollRef: statsScrollRef.current
            });
        break;
    case /* Items */3 :
        tmp = React.createElement(PlUnitItemsSummary.make, {
              showLp: showLp,
              games: matches,
              top: "t0",
              isDuo: filter.typ === /* Duo */4,
              scrollRef: statsScrollRef.current
            });
        break;
    case /* Augments */4 :
        tmp = React.createElement(PlAugmentsSummary.make, {
              showLp: showLp,
              games: matches,
              top: "t0",
              isDuo: filter.typ === /* Duo */4,
              scrollRef: statsScrollRef.current
            });
        break;
    
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "flex flex-col items-center"
                }, React.createElement("div", {
                      className: "w-screen sm:w-auto flex flex-col md:flex-row rounded items-center gap-10 mb-6"
                    }, React.createElement(PlInfo$TopTabs, {
                          tab: filter.typ,
                          onChange: (function (typ) {
                              return Curry._1(setFilter, (function (v) {
                                            return {
                                                    aperture: v.aperture,
                                                    typ: typ
                                                  };
                                          }));
                            }),
                          hasRankedMatches: match$6[0],
                          hasHrMatches: match$6[2],
                          hasDuoMatches: match$6[1],
                          hasNormalMatches: match$6[3]
                        }), React.createElement("div", {
                          className: "bg-bg rounded order-1 md:order-2"
                        }, React.createElement(make, {
                              updating: updating,
                              recentlyUpdated: recentlyUpdated,
                              onUpdatePlayer: onUpdatePlayer,
                              region: region,
                              playerName: player.playerInfo.name,
                              tag: player.playerInfo.tag
                            }))), React.createElement("div", {
                      className: "flex flex-col lg:flex-row lg:items-start"
                    }, React.createElement("div", undefined, React.createElement("div", {
                              className: "lg:hidden mb-4"
                            }, React.createElement(PlBannerHor.make, {
                                  gameType: filter.typ,
                                  matches: matches,
                                  playerCompanionId: companionId,
                                  playerInfo: player.playerInfo,
                                  topRank: match$8 !== 3 ? (
                                      match$8 >= 4 ? topDuoRank : topRank
                                    ) : topHrRank,
                                  league: match$9 !== 3 ? (
                                      match$9 >= 4 ? Belt_Option.flatMap(ranks, (function (ranks) {
                                                return ranks.duo;
                                              })) : Belt_Option.flatMap(ranks, (function (ranks) {
                                                return ranks.ranked;
                                              }))
                                    ) : Belt_Option.flatMap(ranks, (function (ranks) {
                                            return ranks.hr;
                                          })),
                                  localRank: match$10 !== 3 ? (
                                      match$10 >= 4 ? player.playerInfo.duoLocalRank : player.playerInfo.localRank
                                    ) : player.playerInfo.hrLocalRank,
                                  globalRank: match$11 !== 3 ? (
                                      match$11 >= 4 ? player.playerInfo.duoGlobalRank : player.playerInfo.globalRank
                                    ) : player.playerInfo.hrGlobalRank,
                                  stats: seasonStats$1,
                                  altRanks: match$12 !== 0 ? undefined : [
                                      player.playerInfo.duoLeague,
                                      player.playerInfo.hyperrollLeague
                                    ],
                                  ranks: ranks,
                                  hidePctRanks: filter.typ === /* Hyperroll */3
                                })), React.createElement("div", {
                              className: "hidden lg:flex flex-col items-center gap-3"
                            }, React.createElement(PlBanner.make, {
                                  gameType: filter.typ,
                                  matches: matches,
                                  playerCompanionId: companionId,
                                  playerInfo: player.playerInfo,
                                  topRank: match$13 !== 3 ? (
                                      match$13 >= 4 ? topDuoRank : topRank
                                    ) : topHrRank,
                                  league: match$14 !== 3 ? (
                                      match$14 >= 4 ? Belt_Option.flatMap(ranks, (function (ranks) {
                                                return ranks.duo;
                                              })) : Belt_Option.flatMap(ranks, (function (ranks) {
                                                return ranks.ranked;
                                              }))
                                    ) : Belt_Option.flatMap(ranks, (function (ranks) {
                                            return ranks.hr;
                                          })),
                                  localRank: match$15 !== 3 ? (
                                      match$15 >= 4 ? player.playerInfo.duoLocalRank : player.playerInfo.localRank
                                    ) : player.playerInfo.hrLocalRank,
                                  globalRank: match$16 !== 3 ? (
                                      match$16 >= 4 ? player.playerInfo.duoGlobalRank : player.playerInfo.globalRank
                                    ) : player.playerInfo.hrGlobalRank,
                                  hidePctRanks: filter.typ === /* Hyperroll */3
                                }), match$17 !== 0 || !(Belt_Option.isSome(player.playerInfo.hyperrollLeague) || Belt_Option.isSome(player.playerInfo.duoLeague)) ? null : React.createElement(PlAltRanks.make, {
                                    hrRank: Belt_Option.flatMap(ranks, (function (ranks) {
                                            return ranks.hr;
                                          })),
                                    duoRank: Belt_Option.flatMap(ranks, (function (ranks) {
                                            return ranks.duo;
                                          }))
                                  }), React.createElement(PlGlobalStats.make, {
                                  stats: seasonStats$1
                                }))), React.createElement("div", {
                          className: "flex flex-col items-center"
                        }, React.createElement(PlCurrentPerformance.make, {
                              allRankedGames: Belt_Array.keep(allMatches$1, (function (mi) {
                                      return mi.queueId === Belt_Option.getWithDefault(queueId, 1100);
                                    })),
                              setExpandedMatchId: setExpandedMatchId,
                              queueId: Belt_Option.getWithDefault(queueId, 1100)
                            }), React.createElement(ContentSection.make, {
                              className: "lg:ml-6 flex-1 sm:w-[651px] xl:w-[726px]",
                              children: null,
                              noPadding: true
                            }, matches.length !== 0 ? React.createElement("div", {
                                    className: "flex justify-between p-3 sm:p-0 sm:flex-row items-center"
                                  }, React.createElement("div", {
                                        className: ""
                                      }, React.createElement("div", {
                                            className: "sm:hidden"
                                          }, React.createElement(Select.make, {
                                                options: [
                                                  [
                                                    /* Stats */0,
                                                    "Stats"
                                                  ],
                                                  [
                                                    /* Units */1,
                                                    "Units"
                                                  ],
                                                  [
                                                    /* Traits */2,
                                                    "Traits"
                                                  ],
                                                  [
                                                    /* Items */3,
                                                    "Items"
                                                  ],
                                                  [
                                                    /* Augments */4,
                                                    "Augments"
                                                  ]
                                                ],
                                                value: tab,
                                                setValue: (function (v) {
                                                    return Curry._1(setTab, (function (param) {
                                                                  return v;
                                                                }));
                                                  }),
                                                toKey: tabToKey,
                                                fromKey: tabFromKey
                                              })), React.createElement("div", {
                                            className: "hidden sm:block"
                                          }, React.createElement(Tabs, {
                                                children: null,
                                                value: tab,
                                                onChange: (function (param, v) {
                                                    return Curry._1(setTab, (function (param) {
                                                                  return v;
                                                                }));
                                                  })
                                              }, React.createElement(Tab, {
                                                    label: "Stats",
                                                    value: /* Stats */0
                                                  }), React.createElement(Tab, {
                                                    label: "Units",
                                                    value: /* Units */1
                                                  }), React.createElement(Tab, {
                                                    label: "Traits",
                                                    value: /* Traits */2
                                                  }), React.createElement(Tab, {
                                                    label: "Items",
                                                    value: /* Items */3
                                                  })))), filterEl) : React.createElement("div", {
                                    className: "flex items-center justify-between"
                                  }, React.createElement("div", {
                                        className: "pl-4"
                                      }, "No matches matching selection"), filterEl), React.createElement("div", {
                                  ref: statsScrollRef,
                                  className: "y-scroll sm:h-[715px] md:h-[735px]"
                                }, tmp)))), allMatches$1.length !== 0 ? React.createElement(React.Fragment, undefined, React.createElement("div", {
                            className: "mt-7"
                          }, React.createElement(AdHorInContent.make, {
                                renderVisibleOnly: false,
                                key: adKey
                              })), React.createElement("div", {
                            className: "mt-7"
                          }, React.createElement(PlMatchList.make, {
                                pendingQueueId: player.pendingQueueId,
                                typ: filter.typ,
                                heroParticipants: allMatches$1,
                                onShowDetails: onShowDetails,
                                top: 48,
                                onHoverMatch: onHoverMatch
                              }))) : null, showPlayerRadarInfo ? React.createElement(Modal, {
                        BackdropProps: {
                          className: CssJs.style([CssJs.important(CssJs.backgroundColor(CssJs.rgba(0, 0, 0, {
                                              NAME: "num",
                                              VAL: 0.6
                                            })))])
                        },
                        open: showPlayerRadarInfo,
                        onClose: (function (param) {
                            return Curry._1(setShowPlayerRadarInfo, (function (param) {
                                          return false;
                                        }));
                          }),
                        children: React.createElement("div", {
                              className: CssJs.style([
                                    CssJs.outline(CssJs.px(0), CssJs.solid, CssJs.transparent),
                                    CssJs.position(CssJs.absolute),
                                    CssJs.left(CssJs.pct(50)),
                                    CssJs.top(CssJs.pct(50)),
                                    CssJs.transform(CssJs.translate(CssJs.pct(-50), CssJs.pct(-50)))
                                  ])
                            }, React.createElement(Paper, {
                                  children: React.createElement(PlayerRadarModalContents.make, {
                                        onClose: (function (param) {
                                            return Curry._1(setShowPlayerRadarInfo, (function (param) {
                                                          return false;
                                                        }));
                                          })
                                      })
                                }))
                      }) : null));
}

var make$1 = React.memo(PlInfo);

export {
  TopTabs ,
  ExtraButtons ,
  tabToKey ,
  tabFromKey ,
  make$1 as make,
  
}
/* make Not a pure module */
